import { useMemo } from "react";
import { AlertTriangle, Clock3, Bell, Car, RefreshCw, MessageCircle } from "lucide-react";
import { daysLeft } from "../lib/finance";
import { waTarget } from "../lib/wa";

export function InspectionAlerts({ vehicles = [], customers = [], onOpenRenewals }) {
  const buckets = useMemo(() => {
    const b = { overdue: [], "7": [], "30": [], "60": [] };
    for (const v of vehicles) {
      if (!v.inspectionEnd) continue;
      const dl = daysLeft(v.inspectionEnd);
      if (dl < 0) b.overdue.push({ ...v, dl });
      else if (dl <= 7) b["7"].push({ ...v, dl });
      else if (dl <= 30) b["30"].push({ ...v, dl });
      else if (dl <= 60) b["60"].push({ ...v, dl });
    }
    return b;
  }, [vehicles]);
  const total = buckets.overdue.length + buckets["7"].length + buckets["30"].length + buckets["60"].length;
  if (total === 0) return null;
  const customerPhone = (name) => {
    const c = customers.find((x) => (x.name || "").trim().toLocaleLowerCase("tr") === (name || "").trim().toLocaleLowerCase("tr"));
    return c?.phone || "";
  };
  const groups = [
    { key: "overdue", tone: "danger", label: "Gecikti", note: "Hemen arayın", icon: AlertTriangle, items: buckets.overdue },
    { key: "7", tone: "danger", label: "7 gün", note: "Bu hafta", icon: AlertTriangle, items: buckets["7"] },
    { key: "30", tone: "warning", label: "30 gün", note: "Bu ay içinde", icon: Clock3, items: buckets["30"] },
    { key: "60", tone: "info", label: "60 gün", note: "Planlamaya al", icon: Bell, items: buckets["60"] },
  ];
  return (
    <section className="renewal-alerts" data-testid="inspection-alerts" style={{ marginTop: 16 }}>
      <div className="renewal-alerts-head">
        <div>
          <div className="eyebrow"><Car size={13} /> MUAYENE UYARILARI</div>
          <h2 data-testid="inspection-alerts-total">{total} aracın muayene tarihi yaklaşıyor</h2>
          <p>Gecikmiş, 7, 30 ve 60 gün eşiklerinde uyarı. Takvime abone olduğunuzda 14 gün önce otomatik hatırlatma gelir.</p>
        </div>
        <button className="outline-button" data-testid="inspection-open-renewals" onClick={onOpenRenewals}><RefreshCw size={15} /> Yenilemelere git</button>
      </div>
      <div className="renewal-buckets">
        {groups.filter((g) => g.items.length > 0).map((g) => (
          <div className={`renewal-bucket renewal-bucket-${g.tone}`} key={g.key} data-testid={`inspection-bucket-${g.key}`}>
            <div className="renewal-bucket-head">
              <g.icon size={16} />
              <div>
                <strong>{g.label} · {g.items.length}</strong>
                <span>{g.note}</span>
              </div>
            </div>
            <ul>
              {g.items.slice(0, 5).map((v) => {
                const phone = customerPhone(v.customer);
                const wa = waTarget(phone);
                return (
                  <li key={v.id} data-testid={`inspection-alert-item-${v.id}`} onClick={onOpenRenewals} style={{ cursor: "pointer" }} title="Yenilemelere git">
                    <div>
                      <strong>{v.plate}</strong>
                      <span className="muted small"> · {v.customer || "—"} · {v.dl < 0 ? `${Math.abs(v.dl)}g gecikti` : `${v.dl}g kaldı`}</span>
                    </div>
                    {wa && (
                      <a className="whatsapp-button small" href={`https://wa.me/${wa}?text=${encodeURIComponent(`Merhaba${v.customer ? " " + v.customer : ""},\n\n${v.plate} plakalı aracınızın muayenesinin bitiş tarihi ${v.inspectionEnd}. Randevu almanız için size yardımcı olabilirim.`)}`} target="_blank" rel="noreferrer" data-testid={`inspection-wa-alert-${v.id}`} onClick={(e) => e.stopPropagation()}><MessageCircle size={13} /> WhatsApp</a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
